import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { computed, shallowRef } from 'vue';
import { useAttraqtSearch } from '~/composables/attraqt/useAttraqtIntegration';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useReviews } from '~/composables/_next/useReviews';
export function useSearchRecipesStore() {
  var _useAttraqtSearch = useAttraqtSearch('attraqtSearchResults'),
    attraqtResult = _useAttraqtSearch.result,
    attraqtSearch = _useAttraqtSearch.search;
  var _useReviews = useReviews(),
    fetchAllAverageReviews = _useReviews.fetchAllAverageReviews;
  var _useSearchFacets = useSearchFacets(),
    facets = _useSearchFacets.facets;
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var route = useRoute();
  var _usePagination = usePagination(),
    currentPage = _usePagination.currentPage;
  var searchData = useState('search-data-recipes', function () {
    return shallowRef(null);
  });
  var reviewData = useState('search-reviews-recipes', function () {
    return shallowRef(null);
  });
  var recipeSorting = useState('search-sorting-recipes', function () {
    return null;
  });
  var recipePagination = useState('search-pagination-recipes', function () {
    return null;
  });
  var recipeFacets = useState('search-facets-recipes', function () {
    return null;
  });

  /**
   * The list of searchCategories. Only updates when the `term` of the search
   * changes.
   *
   * @param      {string}   category?   The category string
   * @param      {string}   forcedSort  A forced sort criteria
   * @return     {Promise}  The Attraqt search results
   */
  function searchRecipes(_x, _x2) {
    return _searchRecipes.apply(this, arguments);
  }
  function _searchRecipes() {
    _searchRecipes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(category, forcedSort) {
      var _route$params$term, _attraqtResult$value, _attraqtResult$value$, _attraqtResult$value$2;
      var searchFacets, sortLabel, sortFacet, recipeIds;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            searchFacets = Object.entries(facets.value).flatMap(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];
              if (Array.isArray(value) && value.length === 0 || key === 'type') return [];
              return [{
                id: "facet-".concat(key),
                values: value
              }];
            });
            if (category) searchFacets.push({
              id: 'facet-category',
              values: [category]
            });
            sortLabel = forcedSort !== null && forcedSort !== void 0 ? forcedSort : Array.isArray(route.query.sort) ? route.query.sort[0] : route.query.sort;
            sortFacet = getSortCriteria(sortLabel);
            recipeSorting.value = getRecipeSorting(sortLabel);
            _context.next = 7;
            return attraqtSearch({
              query: (_route$params$term = route.params.term) !== null && _route$params$term !== void 0 ? _route$params$term : '',
              options: {
                limit: 18,
                offset: (currentPage.value - 1) * 18,
                filter: "kind=recipe",
                facets: searchFacets,
                sortBy: [sortFacet]
              }
            });
          case 7:
            // Object.assign is required here to change the reference of the object for reactivity purposes.
            searchData.value = Object.assign({}, attraqtResult.value);
            recipeIds = (_attraqtResult$value = attraqtResult.value) === null || _attraqtResult$value === void 0 ? void 0 : (_attraqtResult$value$ = _attraqtResult$value.data) === null || _attraqtResult$value$ === void 0 ? void 0 : (_attraqtResult$value$2 = _attraqtResult$value$.items) === null || _attraqtResult$value$2 === void 0 ? void 0 : _attraqtResult$value$2.map(function (item) {
              return item.id;
            });
            if (!(recipeIds !== null && recipeIds !== void 0 && recipeIds.length)) {
              _context.next = 13;
              break;
            }
            _context.next = 12;
            return fetchAllAverageReviews(recipeIds);
          case 12:
            reviewData.value = _context.sent;
          case 13:
            recipePagination.value = getRecipePagination(searchData.value);
            recipeFacets.value = getRecipeFacets(searchData.value);
            return _context.abrupt("return", searchData.value);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _searchRecipes.apply(this, arguments);
  }
  var recipes = computed(function () {
    var _searchData$value, _searchData$value$dat;
    var res = searchData === null || searchData === void 0 ? void 0 : (_searchData$value = searchData.value) === null || _searchData$value === void 0 ? void 0 : (_searchData$value$dat = _searchData$value.data) === null || _searchData$value$dat === void 0 ? void 0 : _searchData$value$dat.items.map(function (item) {
      var _reviewData$value;
      var itemReview = (_reviewData$value = reviewData.value) === null || _reviewData$value === void 0 ? void 0 : _reviewData$value[item.id];
      return _objectSpread(_objectSpread({}, item.product), {}, {
        recipeId: item.id,
        rating: itemReview === null || itemReview === void 0 ? void 0 : itemReview.averageRate,
        numReviews: itemReview === null || itemReview === void 0 ? void 0 : itemReview.count
      });
    });
    return res;
  });

  /**
   * Computes available facets based on the `recipeListing` data.
   *
   * @param      {SearchData}  recipeListing  The recipe listing
   * @return     {Facet[]}     The recipe facets.
   */
  function getRecipeFacets(recipeListing) {
    var _recipeListing$data, _recipeListing$data$m;
    var facets = recipeListing === null || recipeListing === void 0 ? void 0 : (_recipeListing$data = recipeListing.data) === null || _recipeListing$data === void 0 ? void 0 : (_recipeListing$data$m = _recipeListing$data.metadata) === null || _recipeListing$data$m === void 0 ? void 0 : _recipeListing$data$m.facets.flatMap(function (facet) {
      var _facet$values, _facet$values2;
      if (!((_facet$values = facet.values) !== null && _facet$values !== void 0 && _facet$values.length)) return [];
      if (facet.attribute === 'recipeIngredients') {
        return [{
          id: facet.attribute,
          label: translate("search.filters.".concat(facet.attribute)),
          options: facet.values.map(function (option) {
            return option.value;
          }),
          type: 'tags',
          defaultOpened: true,
          placeholder: translate('search.filters.ingredientSearchPlaceholder'),
          callout: translate('search.filters.ingredientSearchCallout')
        }];
      } else if (facet.id === 'facet-recipePreparationTime') {
        return [{
          id: 'recipePreparationTime',
          label: translate("search.filters.recipePreparationTime"),
          options: facet.values.map(function (option) {
            return {
              id: option.value,
              count: option.count
            };
          })
        }];
      }
      return [{
        id: facet.attribute,
        label: translate("search.filters.".concat(facet.attribute)),
        options: (_facet$values2 = facet.values) === null || _facet$values2 === void 0 ? void 0 : _facet$values2.map(function (value) {
          return {
            count: value.count,
            id: value.value
          };
        })
      }];
    });
    var facetOrder = ['recipeIngredients', 'recipeBeneficialProperties', 'recipeSpecificProblems', 'recipeAdaptedFor', 'recipeCosmeticFamilies', 'recipeHairTypes', 'recipeSkinTypes', 'recipeDifficulty', 'recipePreparationTime'];
    return facetOrder.flatMap(function (facetId) {
      var facet = facets === null || facets === void 0 ? void 0 : facets.find(function (facet) {
        return facet.id === facetId;
      });
      return facet ? [facet] : [];
    });
  }

  /**
   * Gets the recipe pagination.
   *
   * @param      {SearchData}  recipeListing  The recipe listing
   * @return     {Pagination}  The recipe pagination.
   */
  function getRecipePagination(recipeListing) {
    var _recipeListing$data2;
    var searchMeta = recipeListing === null || recipeListing === void 0 ? void 0 : (_recipeListing$data2 = recipeListing.data) === null || _recipeListing$data2 === void 0 ? void 0 : _recipeListing$data2.metadata;
    if (!searchMeta) return null;
    return {
      count: searchMeta.count,
      pages: Math.ceil(searchMeta.count / searchMeta.limit),
      current: currentPage.value
    };
  }
  var sortingOptions = [{
    type: 'sort',
    id: 'pertinence',
    value: 'sort.pertinence',
    sortCriteria: {}
  }, {
    type: 'sort',
    id: 'latest',
    value: 'sort.latest',
    sortCriteria: {
      attribute: 'ctfCreatedAt',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'oldest',
    value: 'sort.oldest',
    sortCriteria: {
      attribute: 'ctCreatedAt',
      order: 'desc'
    }
  }, {
    type: 'sort',
    id: 'alphabeticalAscending',
    value: 'sort.nameAsc',
    sortCriteria: {
      attribute: 'title',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'alphabeticalDescending',
    value: 'sort.nameDesc',
    sortCriteria: {
      attribute: 'title',
      order: 'desc'
    }
  }];

  /**
   * Gets the sort criteria.
   *
   * @param      {string}  sort    The sort
   * @return     {SortCriteria}  The sort criteria.
   */
  function getSortCriteria(sort) {
    var _sortingOptions$find$, _sortingOptions$find;
    var DEFAULT_SORT_CRITERIA = sortingOptions[0].sortCriteria;
    return (_sortingOptions$find$ = (_sortingOptions$find = sortingOptions.find(function (option) {
      return option.id === sort;
    })) === null || _sortingOptions$find === void 0 ? void 0 : _sortingOptions$find.sortCriteria) !== null && _sortingOptions$find$ !== void 0 ? _sortingOptions$find$ : DEFAULT_SORT_CRITERIA;
  }

  /**
   * Gets the recipe sorting.
   *
   * @param      {string}  sort    The sort
   * @return     {Object}  The recipe sorting.
   */
  function getRecipeSorting(sort) {
    return {
      options: [].concat(sortingOptions),
      selected: sort !== null && sort !== void 0 ? sort : 'pertinence'
    };
  }
  return {
    searchRecipes: searchRecipes,
    recipes: recipes,
    recipePagination: recipePagination,
    recipeFacets: recipeFacets,
    recipeSorting: recipeSorting,
    getRecipeSorting: getRecipeSorting
  };
}